import apiClient from './client';
import type {
  ClassifyIntakeRequestPayload,
  IntakeRequestDetail,
  IntakeRequestFilters,
  IntakeRequestListResponse,
} from '@/types/intake-request';

class IntakeRequestsService {
  private basePath = '/intake-requests';

  async list(params: IntakeRequestFilters = {}): Promise<IntakeRequestListResponse> {
    const { data } = await apiClient.get<IntakeRequestListResponse>(this.basePath, { params });
    return data;
  }

  async getById(id: string): Promise<IntakeRequestDetail> {
    const { data } = await apiClient.get<IntakeRequestDetail>(`${this.basePath}/${id}`);
    return data;
  }

  async unclassifiedCount(): Promise<{ count: number }> {
    const { data } = await apiClient.get<{ count: number }>(`${this.basePath}/unclassified-count`);
    return data;
  }

  async classify(id: string, payload: ClassifyIntakeRequestPayload): Promise<IntakeRequestDetail> {
    const { data } = await apiClient.post<IntakeRequestDetail>(`${this.basePath}/${id}/classify`, payload);
    return data;
  }

  async reclassify(id: string, payload: ClassifyIntakeRequestPayload): Promise<IntakeRequestDetail> {
    const { data } = await apiClient.post<IntakeRequestDetail>(`${this.basePath}/${id}/reclassify`, payload);
    return data;
  }

  async archive(id: string): Promise<IntakeRequestDetail> {
    const { data } = await apiClient.post<IntakeRequestDetail>(`${this.basePath}/${id}/archive`);
    return data;
  }

  async unarchive(id: string): Promise<IntakeRequestDetail> {
    const { data } = await apiClient.post<IntakeRequestDetail>(`${this.basePath}/${id}/unarchive`);
    return data;
  }
}

export const intakeRequestsService = new IntakeRequestsService();
